// extracted by mini-css-extract-plugin
export default {"layout":"NoAuth_layout__4NjZY"};